"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../../Constant");

var _styledTheming = _interopRequireDefault(require("styled-theming"));

var _Label = _interopRequireDefault(require("../Label"));

var _theme, _theme2, _theme3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _templateObject7() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  &:hover {\n    cursor: not-allowed;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  rect:nth-child(odd) {\n    fill: ", ";\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  &:hover {\n    cursor: pointer;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: absolute;\n  cursor: pointer;\n  opacity: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  margin-right: 24px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-family: ", ";\n  font-weight: 700;\n  font-size: 1.5rem;\n  color: ", ";\n\n  cursor: ", ";\n  @media print, screen and (min-width: ", "px) {\n    font-size: 2rem;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  cursor: ", ";\n  border-top: 1px solid ", ";\n\n  &:hover,\n  &:focus-within {\n    background-color: ", ";\n    /* needs to be nested here because we want the hover/focus styles to apply whenever hovered over the entire row, not just the specific elements */\n    label {\n      /* there are several of these throughout this file. Each is necessary to make the cursor a pointer in each situation */\n      cursor: pointer;\n    }\n  }\n\n  ", "\n\n  &:last-child {\n    border-bottom: 1px solid ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var selectedRow = (0, _styledTheming.default)('mode', (_theme = {}, (0, _defineProperty2.default)(_theme, _Constant.Themes.HOMEBRIDGE, _Constant.Color.HOMEBRIDGE_BLUE), (0, _defineProperty2.default)(_theme, "homepoint", _Constant.Color.HOMEPOINT_LIGHT_BLUE), (0, _defineProperty2.default)(_theme, _Constant.Themes.SYNERGY_ONE, _Constant.Color.SYNERGY_ONE_YELLOW_DARK), (0, _defineProperty2.default)(_theme, "caliber", _Constant.Color.CALIBER_ACCENT_BLUE), (0, _defineProperty2.default)(_theme, "figure", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme, "petersendean", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme, "pella", _Constant.Color.MOODY_BLURPLE), (0, _defineProperty2.default)(_theme, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_ARROW_RED), _theme));
var selectedLabel = (0, _styledTheming.default)('mode', (_theme2 = {}, (0, _defineProperty2.default)(_theme2, _Constant.Themes.HOMEBRIDGE, _Constant.Color.DARK_GREY), (0, _defineProperty2.default)(_theme2, "homepoint", _Constant.Color.DARK_GREY), (0, _defineProperty2.default)(_theme2, _Constant.Themes.SYNERGY_ONE, _Constant.Color.SYNERGY_ONE_YELLOW_DARK), (0, _defineProperty2.default)(_theme2, "caliber", _Constant.Color.DARK_GREY), (0, _defineProperty2.default)(_theme2, "figure", _Constant.Color.LIGHT_PURPLE), (0, _defineProperty2.default)(_theme2, "petersendean", _Constant.Color.DARK_GREY), (0, _defineProperty2.default)(_theme2, "pella", _Constant.Color.DARK_GREY), (0, _defineProperty2.default)(_theme2, _Constant.Themes.GUARANTEED_RATE, _Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY), _theme2));
var focusStyles = (0, _styledTheming.default)('mode', (_theme3 = {
  caliber: "\n    &:focus-within {\n      outline: 4px solid ".concat(_Constant.Color.CALIBER_PASTEL_BLUE, ";\n      outline-offset: -4px;\n    }\n  ")
}, (0, _defineProperty2.default)(_theme3, _Constant.Themes.HOMEBRIDGE, "\n    &:focus-within {\n      outline: 4px solid ".concat(_Constant.Color.HOMEBRIDGE_YELLOW_LIGHT, ";\n      outline-offset: -4px;\n    }\n  ")), (0, _defineProperty2.default)(_theme3, _Constant.Themes.GUARANTEED_RATE, "\n  &:focus-within {\n    outline: 4px solid ".concat(_Constant.Color.GUARANTEED_RATE_RAVENSWOOD_GRAY, ";\n    outline-offset: -4px;\n  }\n")), (0, _defineProperty2.default)(_theme3, "homepoint", "\n    &:focus-within {\n      outline: 4px solid ".concat(_Constant.Color.HOMEPOINT_LIGHT_BLUE, ";\n      outline-offset: -4px;\n    }\n  ")), (0, _defineProperty2.default)(_theme3, _Constant.Themes.SYNERGY_ONE, "\n    &:focus-within {\n      outline: 4px solid ".concat(_Constant.Color.SYNERGY_ONE_YELLOW_DARK, ";\n      outline-offset: -4px;\n    }\n  ")), (0, _defineProperty2.default)(_theme3, "figure", "\n    &:focus-within {\n      outline: 4px solid ".concat(_Constant.Color.FOCUS_B, ";\n      outline-offset: -4px;\n      label {\n        color: ").concat(_Constant.Color.PURPLE_RAIN, ";\n      }\n    }\n  ")), (0, _defineProperty2.default)(_theme3, "pella", "\n    &:focus-within {\n      outline: 4px solid ".concat(_Constant.Color.FOCUS_B, ";\n      outline-offset: -4px;\n      label {\n        color: ").concat(_Constant.Color.PURPLE_RAIN, ";\n      }\n    }\n  ")), (0, _defineProperty2.default)(_theme3, "petersendean", "\n    &:focus-within {\n      outline: 4px solid ".concat(_Constant.Color.FOCUS_B, ";\n      outline-offset: -4px;\n      label {\n        color: ").concat(_Constant.Color.PURPLE_RAIN, ";\n      }\n    }\n  ")), _theme3));

var TableRow = _styledComponents.default.tr.attrs(function (_ref) {
  var className = _ref.className,
      fsMask = _ref.fsMask;
  return {
    className: "".concat(fsMask ? 'fs-mask ' : '').concat(className || '', " ")
  };
})(_templateObject(), function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, _Constant.Color.BUBBLE_GREY, _Constant.Color.LIGHT_MEDIUM_BACKGROUND_GREY, focusStyles, _Constant.Color.BUBBLE_GREY);

var Label = (0, _styledComponents.default)(_Label.default)(_templateObject2(), _Constant.Font.SECONDARY_HEADER_FONT, function (props) {
  if (props.checked) {
    return selectedLabel;
  } else if (props.disabled) {
    return _Constant.Color.GREY_4;
  }

  return _Constant.Color.DARK_GREY;
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, _Constant.Width.MD);

var RadioGroup = _styledComponents.default.span(_templateObject3());

var Radio = _styledComponents.default.input(_templateObject4());

var RadioBase = _styledComponents.default.svg(_templateObject5());

var RadioCheckedBase = (0, _styledComponents.default)(RadioBase)(_templateObject6(), selectedRow);

var RadioChecked = function RadioChecked() {
  return /*#__PURE__*/_react.default.createElement(RadioCheckedBase, {
    width: "24",
    height: "25",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("rect", {
    y: "0.5",
    width: "24",
    height: "24",
    rx: "12",
    fill: _Constant.Color.LIGHT_PURPLE
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.3584 10.2456L11.5095 16.0789L8.00011 12.5789",
    stroke: _Constant.Color.WHITE,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

var RadioInactive = function RadioInactive() {
  return /*#__PURE__*/_react.default.createElement(RadioBase, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "11",
    stroke: _Constant.Color.DARK_GREY_2,
    strokeWidth: "2"
  }));
};

var RadioDisabledBase = (0, _styledComponents.default)(RadioBase)(_templateObject7());

var RadioDisabled = function RadioDisabled() {
  return /*#__PURE__*/_react.default.createElement(RadioDisabledBase, {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: _Constant.Color.GREY_3,
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "11"
  }));
};

var TableRowInput = function TableRowInput(_ref2) {
  var id = _ref2.id,
      value = _ref2.value,
      checked = _ref2.checked,
      disabled = _ref2.disabled,
      data = _ref2.data,
      onChange = _ref2.onChange,
      colSpan = _ref2.colSpan,
      fsMask = _ref2.fsMask,
      otherProps = (0, _objectWithoutProperties2.default)(_ref2, ["id", "value", "checked", "disabled", "data", "onChange", "colSpan", "fsMask"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      isFocus = _useState4[0],
      setIsFocus = _useState4[1];

  var inputProps = _objectSpread(_objectSpread({}, otherProps), {}, {
    type: 'radio',
    id: id,
    value: value,
    checked: checked,
    disabled: disabled,
    onChange: function onChange() {}
  });

  var RadioStatus = RadioInactive;

  if (disabled) {
    RadioStatus = RadioDisabled;
  } else if (checked) {
    RadioStatus = RadioChecked;
  } else if (isHovered || isFocus) {
    RadioStatus = RadioInactive;
  }

  var handleMouseOver = function handleMouseOver() {
    setIsHovered(true);
  };

  var handleMouseOut = function handleMouseOut() {
    setIsHovered(false);
  };

  var handleFocus = function handleFocus() {
    setIsFocus(true);
  };

  var handleBlur = function handleBlur() {
    setIsFocus(false);
  };

  return /*#__PURE__*/_react.default.createElement(TableRow, (0, _extends2.default)({
    onClick: function onClick() {
      if (!disabled) onChange(value);
    },
    onKeyDown: function onKeyDown() {
      if (!disabled) onChange(value);
    },
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut,
    onFocus: handleFocus,
    onBlur: handleBlur,
    checked: checked,
    disabled: disabled,
    fsMask: fsMask
  }, otherProps), data.map(function (d, i) {
    return /*#__PURE__*/_react.default.createElement("td", {
      colSpan: d.colSpan || colSpan,
      key: d.content || d,
      checked: checked,
      disabled: disabled
    }, i === 0 && /*#__PURE__*/_react.default.createElement(RadioGroup, null, /*#__PURE__*/_react.default.createElement(Radio, inputProps), /*#__PURE__*/_react.default.createElement(RadioStatus, null)), /*#__PURE__*/_react.default.createElement(Label, {
      htmlFor: id,
      checked: checked,
      disabled: disabled
    }, d.content || d));
  }));
};

TableRowInput.propTypes = {
  /** The id for the input */
  id: _propTypes.default.string.isRequired,

  /** Value that controls the Radio */
  value: _propTypes.default.string.isRequired,

  /** Whether or not the checkbox is checked */
  checked: _propTypes.default.bool,

  /** Whether or not to disable the checkbox */
  disabled: _propTypes.default.bool,
  data: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.shape({
    content: _propTypes.default.node,
    colSpan: _propTypes.default.number
  })])).isRequired,

  /** Function used to update the value prop */
  onChange: _propTypes.default.func.isRequired,

  /** Specifies the number of columns a cell should span. Note: colspan="0" tells the browser to span the cell to the last column of the column group (colgroup) */
  colSpan: _propTypes.default.number,

  /** Toggles masking input within FullStory */
  fsMask: _propTypes.default.bool
};
TableRowInput.defaultProps = {
  checked: false,
  disabled: false,
  colSpan: null,
  fsMask: true
};
var _default = TableRowInput;
exports.default = _default;